import React, {type FC} from 'react'
import clsx from 'clsx'
import gallowIcon from '../img/gallow.png'
import styles from './Loader.scss'

export type LoaderProps = {
  size?: 'big' | 'small';
}

export const Loader: FC<LoaderProps> = ({size = 'big'}) => {

  return (
    <div className={styles.wrapper}>
      <img className={styles[`icon--${size}`]} src={gallowIcon} />
      <div className={clsx(styles.shimmerWrapper, styles[`shimmerWrapper--${size}`])}>
        <div className={clsx(styles.shimmer, styles[`shimmer--${size}`])}></div>
      </div>
    </div>
  )
}
